

import _ from "lodash";

import { nanoid } from 'nanoid';
import { utilsItemGenKey } from "~~/utils/utilItems";

export const useCartItemsStore = defineStore("cartItems", {
    state: () => {
        return {

            items: [] as any,

        };
    },

    actions: {
        addItem(item) {
            // check if item already in cart and increment qty
            let options2 = _buildOptions2(item._options)
            let __cartkey = utilsItemGenKeyInCart(item, options2)
            let index = this.items.findIndex((i: any) => i.__cartkey === __cartkey)

            if (index >= 0) {

                this.items[index].qty += 1;

                return;
            }

            this.items.push({
                uuid: nanoid(8),
                productId: item.productId,
                name: item.name,
                options: item.options || null,
                _options: item._options || null,// item._options || [],
                options2: _buildOptions2(item._options) || null,
                qty: item?.qty || 1,
                price: parseFloat(item.price),
                tax: [2, 7],
                discountItem: [0, 0],
                __cartkey: __cartkey,
                comments : item.comments || null,
            });
        },

        // เพิ่มด่วน: สั่งซ้ำของที่ติ๊กไว้บนพาเนลโต๊ะ
        //
        // ไม่เรียก addItem() เพราะตัวนั้นสร้าง options2 จาก item._options
        // ซึ่งรายการที่สั่งไปแล้วไม่มีติดมาจาก jobchain ท็อปปิ้งจะหายหมด
        // ตรงนี้จึงคัด options2 ที่บันทึกไว้แล้วมาใช้ตรง ๆ
        //
        // สั่งซ้ำครั้งละ 1 ชิ้นเสมอ ไม่ใช่จำนวนเท่าของเดิม
        // (ลูกค้าสั่งเพิ่มทีละชิ้นเป็นเรื่องปกติ ส่วนจะเพิ่มจำนวนก็ปรับในตะกร้าได้)
        quickAddItems(sourceItems: Array<any>) {
            sourceItems.forEach((item) => {
                const options2 = _.cloneDeep(item.options2 || null);
                const prepared = {
                    productId: item.productId,
                    name: item.name,
                    comments: item.comments || null,
                    price: parseFloat(item.price),
                };
                const __cartkey = utilsItemGenKeyInCart(prepared, options2);
                const index = this.items.findIndex((i: any) => i.__cartkey === __cartkey);

                if (index >= 0) {
                    this.items[index].qty += 1;
                    return;
                }

                this.items.push({
                    ...prepared,
                    uuid: nanoid(8),
                    options: _.cloneDeep(item.options || null),
                    _options: null,
                    options2,
                    qty: 1,
                    tax: [2, 7],
                    discountItem: [0, 0],
                    __cartkey,
                });
            });
        },

        updateItem(itemModified: any) {       
            // find id match in items then replace
            const index = this.items.findIndex((i) => i.uuid === itemModified.uuid);
            if (index >= 0) {
                this.items[index] = itemModified
                this.items[index].options2 = _buildOptions2(itemModified._options) || null
            }
            let options2 = _buildOptions2(itemModified._options)
            let __cartkey = utilsItemGenKeyInCart(itemModified, options2)
            itemModified.__cartkey = __cartkey
        },

        removeItem(itemModified) {
            // find id match in items then replace
            const index = this.items.findIndex((i) => i.uuid === itemModified.uuid);
            if (index >= 0) {
                this.items.splice(index, 1)
            }


        },

        removeItemAt(index) {
            this.items.splice(index, 1)
        },

        // incrementItemQty(value: number, index: number) {
        //     this. items[index].qty += value
        // },

        clear() {
            // items = []
            this.items.splice(0, this.items.length)
        },


    },
});


function _buildOptions2(optionsGroupList = []) {
    let options2 = []

    if (optionsGroupList === null) {
        return options2
    }

    for (let index = 0; index < optionsGroupList.length; index++) {

        const optionsGroup = optionsGroupList[index];
        if (optionsGroup?.items) {
            optionsGroup?.items.forEach((option) => {
                option.qty && options2.push({
                    ...option
                })
            })
        }
    }
    return options2
}